import { createContext, Dispatch, SetStateAction } from 'react';

import { CreateWebhookFormStepsType } from './CreateWebhookModalContent';

interface CreateWebhookContextType {
    activeFormStep: CreateWebhookFormStepsType;
    setActiveFormStep: Dispatch<SetStateAction<CreateWebhookFormStepsType>>;
    onDismiss: () => void;
}

export const CreateWebhookContext = createContext<CreateWebhookContextType>({} as CreateWebhookContextType);
